module.exports = __webpack_public_path__ + "static/media/subscribeDiscount.3a2ff052.svg";